import * as React from "react"
import * as styles from "./styles.css"
import { MerlinStatus } from "@gatsbyjs/graphql/types"
import { statusIcons } from "../../constants/status-details"
import { clsx } from "clsx"

type StatusPillProps = {
  status: string
  formattedStatusText: string
}

export function StatusPill({ status, formattedStatusText }: StatusPillProps) {
  const success = MerlinStatus.Success === status
  const inProgress = MerlinStatus.InProgress === status
  const failed = MerlinStatus.Failed === status
  const idle = MerlinStatus.Idle === status
  const statusIcon = statusIcons?.[status]

  const pillStyle = clsx({
    [styles.statusPillSuccess]: success,
    [styles.statusPillInProgress]: inProgress,
    [styles.statusPillFailed]: failed,
    [styles.statusPillIdle]: idle,
  })

  return (
    <div className={pillStyle}>
      <div className={styles.statusPillContent}>
        {statusIcon}
        <p className={styles.statusPillText}>{formattedStatusText}</p>
      </div>
    </div>
  )
}
